import MgidCampaignModel from './MgidCampaignModel';
import ExportModel from '../../lib/ExportModel';

export default {
  async getConfig(account) {
    // Create Campaign Model
    const campaignModel = new MgidCampaignModel(account);
    return ExportModel(campaignModel);
  },
};
